(function () {
  var allowedPath = '/pages/测试表单';
  if (decodeURIComponent(window.location.pathname) !== allowedPath) return;

  function getEmbed() {
    return document.querySelector('shopify-forms-embed');
  }

  function getRoot() {
    var embed = getEmbed();
    return embed && embed.shadowRoot ? embed.shadowRoot : null;
  }

  function getApp() {
    var root = getRoot();
    return root ? root.querySelector('#app-embed') : null;
  }

  function createUI() {
    if (document.querySelector('.sc-easter-egg-btn')) return;

    var style = document.createElement('style');
    style.innerHTML = `
      .sc-easter-egg-btn {
        position: fixed !important;
        left: 80px !important;
        bottom: 130px !important;
        width: 70px !important;
        height: 70px !important;
        border-radius: 999px !important;
        border: 0 !important;
        background: red !important;
        font-size: 36px !important;
        z-index: 2147483647 !important;
        cursor: pointer !important;
      }

      .sc-egg-mask {
        display: none;
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,.48);
        z-index: 2147483645;
      }

      .sc-egg-modal-guide {
        display: none;
        position: fixed;
        left: 50%;
        top: 50%;
        width: 430px;
        max-width: calc(100vw - 32px);
        min-height: 390px;
        transform: translate(-50%, -50%);
        z-index: 2147483646;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);

    var egg = document.createElement('button');
    egg.className = 'sc-easter-egg-btn';
    egg.type = 'button';
    egg.innerHTML = '🥚';

    var mask = document.createElement('div');
    mask.className = 'sc-egg-mask';

    var modalGuide = document.createElement('div');
    modalGuide.className = 'sc-egg-modal-guide';

    document.body.appendChild(mask);
    document.body.appendChild(modalGuide);
    document.body.appendChild(egg);

   function openEggForm() {
  var root = getRoot();
  var app = getApp();

  if (!root || !app) {
    console.log('Forms 还没加载出来');
    return;
  }

  mask.style.display = 'block';
  modalGuide.style.display = 'block';

  app.style.setProperty('display', 'block', 'important');
  app.style.setProperty('opacity', '1', 'important');
  app.style.setProperty('visibility', 'visible', 'important');
  app.style.setProperty('pointer-events', 'auto', 'important');

  var target =
    root.querySelector('button[aria-haspopup="dialog"]') ||
    root.querySelector('button[aria-label*="miss"]') ||
    root.querySelector('button[class*="teaser"]') ||
    root.querySelector('[class*="teaser"]') ||
    app;

  ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (type) {
    target.dispatchEvent(new MouseEvent(type, {
      bubbles: true,
      cancelable: true,
      composed: true,
      view: window
    }));
  });

  setTimeout(centerFormsPopup, 200);
  setTimeout(centerFormsPopup, 500);
  setTimeout(centerFormsPopup, 1000);

  // 关键：监听插件自己的 X 关闭后，恢复状态
  setTimeout(function () {
    var closeBtn =
      root.querySelector('button[aria-label="Close"]') ||
      root.querySelector('button[aria-label="关闭"]') ||
      root.querySelector('button[class*="close"]') ||
      root.querySelector('[class*="close"]');

    if (closeBtn && !closeBtn.dataset.scEggBound) {
      closeBtn.dataset.scEggBound = 'true';

      closeBtn.addEventListener('click', function () {
        mask.style.display = 'none';
        modalGuide.style.display = 'none';

        setTimeout(function () {
          var app = getApp();
          if (app) {
            app.style.removeProperty('display');
            app.style.removeProperty('opacity');
            app.style.removeProperty('visibility');
            app.style.removeProperty('pointer-events');
            app.style.removeProperty('position');
            app.style.removeProperty('left');
            app.style.removeProperty('top');
            app.style.removeProperty('right');
            app.style.removeProperty('bottom');
            app.style.removeProperty('transform');
            app.style.removeProperty('z-index');
          }
        }, 300);
      });
    }
  }, 600);
}

    function centerFormsPopup() {
      var app = getApp();
      if (!app) return;

      app.style.setProperty('display', 'block', 'important');
      app.style.setProperty('position', 'fixed', 'important');
      app.style.setProperty('left', '50%', 'important');
      app.style.setProperty('top', '50%', 'important');
      app.style.setProperty('right', 'auto', 'important');
      app.style.setProperty('bottom', 'auto', 'important');
      app.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
      app.style.setProperty('z-index', '2147483647', 'important');
    }

 function closeEggForm() {
  mask.style.display = 'none';
  modalGuide.style.display = 'none';

  var root = getRoot();

  if (root) {

    // 找插件自己的关闭按钮
    var closeBtn =
      root.querySelector('button[aria-label="Close"]') ||
      root.querySelector('button[aria-label="关闭"]') ||
      root.querySelector('button[class*="close"]') ||
      root.querySelector('[class*="close"]');

    // 真正点击插件自己的 X
    if (closeBtn) {
      closeBtn.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        composed: true,
        view: window
      }));
    }
  }

  setTimeout(function () {
    var app = getApp();

    if (app) {
      app.style.removeProperty('display');
      app.style.removeProperty('opacity');
      app.style.removeProperty('visibility');
      app.style.removeProperty('pointer-events');
      app.style.removeProperty('position');
      app.style.removeProperty('left');
      app.style.removeProperty('top');
      app.style.removeProperty('right');
      app.style.removeProperty('bottom');
      app.style.removeProperty('transform');
      app.style.removeProperty('z-index');
    }
  }, 200);
}

    egg.addEventListener('click', openEggForm);

setInterval(function () {
  var root = getRoot();
  var app = getApp();
  if (!root || !app) return;

  var mask = document.querySelector('.sc-egg-mask');
  var modalGuide = document.querySelector('.sc-egg-modal-guide');
  if (!mask || mask.style.display === 'none') return;

  var dialog = root.querySelector('[role="dialog"], [aria-modal="true"]');

  var appStyle = window.getComputedStyle(app);
  var dialogVisible = dialog && window.getComputedStyle(dialog).display !== 'none';

  var appHidden =
    appStyle.display === 'none' ||
    appStyle.visibility === 'hidden' ||
    appStyle.opacity === '0';

  if (!dialogVisible || appHidden) {
    mask.style.display = 'none';
    if (modalGuide) modalGuide.style.display = 'none';
  }
}, 300);

    mask.addEventListener('click', closeEggForm);
  }

  createUI();
})();